@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/lists";

f-list {
  ul:not([class]) {
    @include lists.list;
    @include lists.dotted;
  }

  ol:not([class]) {
    @include lists.list;
    @include lists.num;
  }

  .a-list {
    @include lists.list;

    &--dot {
      @include lists.variant("dotted");
    }

    &--check {
      @include lists.variant("checked");
    }

    &--num {
      @include lists.variant("numbers");
    }

    &--spaced {
      @include lists.variant("spaced");
    }

    &--transparent {
      @include bcp.decl(list, direction, column, true);
      @include bcp.decl(list, row-gap, 0, true);
      @include bcp.decl(list, column-gap, 0, true);
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
